/** @jsxImportSource @emotion/react */
import React from "react";
import { primaryTextColor } from "./LayoutStyle";
import styled from "@emotion/styled";
import { useIsMobile } from "hooks/useDeviceType";

export const ActivityHeader: React.FC = props => {
  const isMobile = useIsMobile();
  return <Header isMobile={isMobile}>Transactions</Header>;
};

// Sub-components

const Header = styled.h2<{ isMobile: boolean }>`
  margin-bottom: 0; // 0 for now because bootstrap applies default margin-bottom to h2's
  padding: ${props => (props.isMobile ? "10px 0" : "0")};
  font-size: ${props => (props.isMobile ? props.theme.fontSize[7] : props.theme.fontSize[10])};
  ${primaryTextColor}
`;
